<template>
  <router-layout id="__index">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <!--
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      -->
    <TabBar></TabBar>
     <!--mask layer--> 
    <section class="welcome" v-show="welcome" transition="welcome"></section>
    <section class="mobile-tips" style="dislay:none;" v-show="isnotMobile">
        <div class="mobile-tips-inner">
            <div class="mobile-model"> <img src="../assets/images/mobile.png" alt=""></div>
            <p style="margin:10px 0;">为保证最佳用户体验：</p>
            <p style="margin:10px 0;text-align:left;diplay:block;">1.请用chrome移动设备调试模式(F12)下打开</p>
            <p style="margin:10px 0;text-align:left;diplay:block;">2.手机浏览器访问</p>
            <br>
            <button v-on:click='closeTip' class="btn btn-orange" style="width:80px;height:35px;font-size:16px;">关闭</button>
        </div>
    </section>
  
  </router-layout>
 
</template>
<script>
require('../assets/css/base.css')

import TabBar from '../components/TabBar'
export default {
  components:{
    TabBar
  },
  data () {
     return {
        welcome: false,//欢迎页
        isnotMobile:false//是否为移动设备访问
      }
  },
  mounted () {   
  },
  computed:{
    //   key(){
    //       return this.$route.name?this.$route.name+ +new Date():this.$route+ +new Date()
    //   }
  },
  created() {
      /*
        let isMobile = function(){
            let userAgentInfo = navigator.userAgent;
            let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod")
            let flag = false;
            for (let v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = true; break; }
            };
            return flag;
        }();
        if(!isMobile){
            this.isnotMobile = true;
        }
        if (this.$route.matched.length === 1) {
            this.welcome = true;
        }
        setTimeout(() => {
            this.welcome = false;
        }, 2000)
        */
    },
    methods:{
      closeTip(){
        this.isnotMobile=false;
      },
     
    }
}
</script>
<style scoped>
.welcome {
    width: 100%;
    height: 100%;
    z-index: 1000;
    position: fixed;
    left: 0;
    top: 0;
    transition: .25s all linear;
    background: url(../assets/images/launchimage.png) no-repeat center center;
    background-size: cover;
}
.welcome-leave {
    opacity: 0;
}
.mobile-tips{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background-color: rgba(0,0,0,.75);
    text-align: center;
    color: #cccccc;
    display: flex;
    justify-content: center;
    align-items: center;
}
.mobile-tips-inner{
    width: 330px;
    padding-bottom: 200px;
}
.mobile-model{
    flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue